import { RouteObject } from "react-router-dom";
import NFCeView from "./NFCe.View";
import NFCeConsultaView from "./Consulta/NFCe.Consulta.View";
import { NFCeImprimirView } from "./NFCe.Imprimir.View";
import NFCeVisualizaView from "./Consulta/NFCe.Visualiza.View";


export const NFCeRoutes: RouteObject[] = [
  {
    path: "fiscal/nfce",
    element: <NFCeView />,
  },
  {
    path: "fiscal/nfce/consulta",
    element: <NFCeConsultaView />,
  },
  {
    path: "fiscal/nfce/consulta/:nfceId/imprimir",
    element: <NFCeImprimirView />,
  },
  {
    path: "fiscal/nfce/consulta/:id/visualizar",
    element: <NFCeVisualizaView />,
  },
];
